$(function() {

    $.video = {};

    // durations

    $.video.duration = '50%';

    $.video.endDuration = '50%';

    // timelines

    $.video.tl = {};

    // in

	$.video.tl.in = new TimelineMax();

    $.video.tl.in.addLabel("start");
    $.video.tl.in.addLabel("content", 2);

    $.video.tl.in.set("#video-container", { visibility: "visible" }, "start");﻿

    $.video.tl.in.fromTo("#video-container .iframe-container", 1, { opacity:0 }, { opacity:1 }, "start");

    new ScrollMagic.Scene({ triggerElement: '#video-pin', triggerHook: 'onEnter', duration: $.video.duration })
    	.setTween($.video.tl.in)
    	// .addIndicators({name: 'video in'})
    	.addTo($.controller);

    $.video.tl.out = new TimelineMax();

    $.video.tl.out.addLabel("start");

    $.video.tl.out.to("#video-container .iframe-container", 1, { opacity:0, delay:1 }, "start");

    new ScrollMagic.Scene({ triggerElement: '#video-end', triggerHook: 'onCenter', duration: $.video.endDuration })
        .setTween($.video.tl.out)
        // .addIndicators({name: 'video out'})
        .addTo($.controller);

});
